module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects,
      "hideFooter": true
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [(_vm.connects) ? _c('div', {
    slot: "header"
  }, [_vm._v("\n    " + _vm._s(_vm.connects.assistType === 'Manual' ? _vm.attrText.manualAssist : _vm.attrText.operationAssist) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.initLoading) ? _c('div', {
    staticClass: "loading",
    slot: "content"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/loading.gif")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initLoading) ? _c('div', {
    staticClass: "assist-content",
    slot: "content"
  }, [_c('translate', {
    staticClass: "tip-name",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Connection Info")]), _vm._v(" "), _c('div', {
    staticClass: "connect-detail"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "detail-tip",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Host")]), _vm._v("\n          :\n        ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.connectionInfo.host))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.connectionInfo.host),
      expression: "connectionInfo.host",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticClass: "copy",
    attrs: {
      "span": 4
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "detail-tip",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Port")]), _vm._v("\n          :\n        ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.connectionInfo.port))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.connectionInfo.port),
      expression: "connectionInfo.port",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticClass: "copy",
    attrs: {
      "span": 4
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "detail-tip",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Username")]), _vm._v("\n          :\n        ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.connectionInfo.username))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.connectionInfo.username),
      expression: "connectionInfo.username",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticClass: "copy",
    attrs: {
      "span": 4
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "detail-tip",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("SSH command")]), _vm._v("\n          :\n        ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.sshLink
    }
  }, [_vm._v(_vm._s(_vm.sshCommand))])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.sshCommand),
      expression: "sshCommand",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticClass: "copy",
    attrs: {
      "span": 4
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "detail-tip detail-usename",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Connect Username")]), _vm._v("\n          :\n        ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-input', {
    staticClass: "user-input",
    model: {
      value: (_vm.connectionInfo.defaultName),
      callback: function($$v) {
        _vm.connectionInfo.defaultName = $$v
      },
      expression: "connectionInfo.defaultName"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "copy",
    attrs: {
      "span": 4
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('el-button', {
    staticClass: "connect-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.connectHost()
      }
    }
  }, [_c('translate', [_vm._v("Connect")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "tip-name"
  }, [_c('translate', [_vm._v("Assistance Info")])], 1), _vm._v(" "), (_vm.connects && _vm.connects.assistType === 'Manual') ? _c('div', {
    staticClass: "get-assist-info"
  }, [(!_vm.assistInfo) ? _c('translate', {
    staticClass: "connect-host",
    attrs: {
      "tag": "h5"
    }
  }, [_vm._v("\n        Please connect to the host for assistance information\n      ")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "height": "300px"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.assistInfo) ? _c('el-button', {
    staticClass: "re-get",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.getAssistInfo(_vm.connectionInfo.code)
      }
    }
  }, [_c('translate', [_vm._v("Get Again")])], 1) : _vm._e(), _vm._v(" "), (_vm.assistInfo) ? _c('div', [_c('div', {
    staticClass: "assist-detail"
  }, [_c('translate', {
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Temporary assistance link are created successfully and can be sent to assistants!\n          ")]), _vm._v(" "), _c('p', [_c('translate', [_vm._v("Assistance address")]), _vm._v("\n            : " + _vm._s(_vm.assistLink) + " "), _c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.assistLink),
      expression: "assistLink",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticClass: "copy",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)], 1), _vm._v(" "), _c('translate', {
    staticClass: "tip-msg",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("\n            (Valid time:30 minutes or the main connection is disconnected)\n          ")])], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.connects && _vm.connects.assistType === 'Operation') ? _c('div', {
    staticClass: "get-assist-info"
  }, [_c('translate', {
    staticClass: "connect-host",
    attrs: {
      "tag": "h5"
    }
  }, [_vm._v("Please connect to the host for assistance information")]), _vm._v(" "), (!_vm.loading && !_vm.assistInfo) ? _c('el-button', {
    staticClass: "re-get",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.getAssistInfo(_vm.connectionInfo.code)
      }
    }
  }, [_c('translate', [_vm._v("Get Again")])], 1) : _vm._e(), _vm._v(" "), (_vm.loading && !_vm.assistInfo || _vm.assistInfo) ? _c('div', [_c('div', {
    staticClass: "assist-ewm"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "img-cover"
  }, [_c('img', {
    staticClass: "img-cover-bg",
    attrs: {
      "src": require("../../../assets/ewm.png"),
      "width": "168",
      "height": "168"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-bg"
  }, [_c('div', {
    staticClass: "loadEffect"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])]) : _vm._e(), _vm._v(" "), (_vm.assistInfo) ? _c('qr-code', {
    staticClass: "ewm-img",
    attrs: {
      "text": _vm.assistInfo.url,
      "size": 150,
      "color": "#000",
      "bg-color": "#fff",
      "error-level": "L",
      "title": "333"
    }
  }) : _vm._e(), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Use the operation and maintenance assistant to scan the above two-dimensional code\n          ")]), _vm._v(" "), _c('translate', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Please download ")]), _vm._v(" "), _c('img', {
    staticClass: "app-store",
    attrs: {
      "src": require("../../../assets/appstore.png"),
      "alt": "app 下载"
    }
  })], 1)]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4a35df2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/model/workgroup-assist.vue
// module id = 613
// module chunks = 4 5 6